import { useRouter, useContext } from '@nuxtjs/composition-api';
import type { Product } from '~/modules/catalog/product/types';
import useCart from '~/modules/checkout/composables/useCart';
import { useProduct } from '~/modules/catalog/product/composables/useProduct';
import useCustomAddToCart from '~/composables/useCustomAddToCart';

export const useAddToCart = () => {
  const {
    cart,
    addItem: addItemToCartBase,
    isInCart,
  } = useCart();
  const router = useRouter();
  const { app } = useContext();
  const { getProductPath } = useProduct();
  const { addItem } = useCustomAddToCart()
  const addItemToCart = async (params: { product: Product, quantity: number }) => {
    const { product, quantity } = params;
    // @ts-ignore
    // eslint-disable-next-line no-underscore-dangle
    const productType = product.__typename;

    console.log(cart)

    switch (productType) {
      case 'SimpleProduct':
        await addItem(cart.value.id, [{sku: product.sku, quantity}])
        break;
      case 'BundleProduct':
      case 'ConfigurableProduct':
      case 'GroupedProduct':
        const path = app.localeRoute(getProductPath(product));

        await router.push(path);
        break;
      default:
        throw new Error(`Product Type ${productType} not supported in add to cart yet`);
    }

    let productCategories = {}
    if (product.categories) {
      product.categories?.forEach((c, i) => {
        productCategories['item_category' + i] = c.name
      })
    }

    app.$gtm.push({ ecommerce: null })
    app.$gtm.push({
      event: "add_to_cart",
      ecommerce: {
        items: [
        {
          item_name: product.name,
          item_id: product.sku,
          price: product.price_range.maximum_price.final_price.value,
          currency: product.price_range.maximum_price.final_price.currency,
          index: 1,
          quantity: quantity,
          ...productCategories
        }]
      }
    })
  };

  return {
    addItemToCart,
    isInCart,
  };
};
